// extracted by mini-css-extract-plugin
module.exports = {"container":"EmployerHome_container__3nQpf","pContainer":"EmployerHome_pContainer__2pgFG","ptitle":"EmployerHome_ptitle__ZDtnT"};